import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        status="404"
        title="Không tìm thấy"
        subTitle="Trang bạn truy cập không tồn tại"
        extra={<Button type="primary" onClick={() => navigate('/')}>Về trang chủ</Button>}
      />
    </div>
  );
}
